import React from "react";

import ApplyNowButton from "../../../../../components/applynowbutton";

const OutcomesYEE = () => {
  return (
    <div
      className=" py-10 mt-5 rounded-lg bg-gray-900 text-white relative"
      id="outcomes"
    >
      <div className="absolute inset-0 bg-black bg-opacity-50 z-10 rounded-lg"></div>

      <div className="h-full flex items-center justify-center relative z-20 px-10 text-center">
        <div className="max-w-4xl">
          <h2 className="md:text-3xl text-lg font-bold mb-4">
            Undergraduate Certificate/Diploma in Creative Leadership and
            Entrepreneurship
          </h2>
          <div className="bg-sdorange h-1 w-10 mx-auto mb-4"></div>

          <p className="md:text-lg text-base leading-relaxed text-justify">
            The Emerging Entrepreneur course serves as a cornerstone within our
            Undergraduate Certificate (30 credits)/Diploma (60 credits) in
            Creative Leadership & Entrepreneurship, offering students a pathway
            to delve deeper into the realms of innovation, leadership, &
            business acumen. Encompassing a diverse array of courses curated to
            hone entrepreneurial skills & foster creative thinking, this program
            empowers students to emerge as visionary leaders poised to drive
            impactful change in the global business landscape.
          </p>
        </div>
      </div>
      <div
        className="absolute inset-0 bg-cover bg-center rounded-lg"
        style={{ backgroundImage: "url('/image-fix/random-images/r4.jpg')" }}
      ></div>
      <ApplyNowButton />
    </div>
  );
};

export default OutcomesYEE;
